export enum BlockCancelInvoiceActionVariant {
  CreditNote = 'creditNote',
  Void = 'void',
}
